<template>
  <div class="rf-status" v-if="isVisible" :class="computedClass">
    <slot :message="message">
      <pre>{{ message }}</pre>
    </slot>
    <ul>
      <li v-for="(value, key) in items" :key="key">
        <b>{{ key }}:</b>
        <ul v-if="Array.isArray(value)">
          <li v-for="(message, key) in value" :key="key">{{ message }}</li>
        </ul>
        <span v-else>{{ item }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import parentForm from '@/mixins/parentForm'

export default {
  name: 'RfStatus',
  mixins: [parentForm],
  computed: {
    items () {
      return this.parentForm.response.data.errors
    },
    isVisible () {
      // I want to coerce this to a Boolean just because it looks cleaner when inspecting the VM in devtools
      return !!(this.parentForm.response && this.parentForm.response.data)
    },
    message () {
      let message = this.parentForm.response.statusText
      try {
        message = this.parentForm.response.data.error ? this.parentForm.response.data.error.message : message
        message = this.parentForm.response.data.success ? this.parentForm.response.data.success.message : message
      } catch (e) {
        if (!(e instanceof TypeError)) {
          throw e
        }
      }

      if (this.parentForm.freeform && this.parentForm.response.hasErrors) {
        message = 'The following errors were encountered:'
      }

      return message
    },
    computedClass () {
      return {
        'rf-status-error': this.parentForm.response.status >= 400 || (this.parentForm.freeform && this.parentForm.response.hasErrors),
        'rf-status-success': this.parentForm.response.status >= 200 && this.parentForm.response.status < 400
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// RfStatus.vue?f100bdc0